// extracted by mini-css-extract-plugin
export default {"backButton":"PopupHeader_backButton__SCqHz","content":"PopupHeader_content__lu4hU","wrapper":"PopupHeader_wrapper__GP2XO"};